module.exports = __webpack_public_path__ + "static/img/paradise-paloma.91f7a38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sang-pal/paradise-paloma.png
// module id = oCA3
// module chunks = 0